import Testimonial from './Testimonial';

export default Testimonial;



// WEBPACK FOOTER //
// ./src/components/CaseStudyPage/components/Testimonial/index.js